import {
  createProjectFormSubmission as coreCreateProjectFormSubmission,
  fetchProjectFileData as coreFetchProjectFileData,
} from '@witmetrics/unison-core';
import { API } from '@/api';
import type { Answers } from '@/providers/FormProvider';

export const createProjectFormSubmission = (
  projectId: number,
  versionId: number,
  answers: Answers
) => coreCreateProjectFormSubmission(API, projectId, versionId, answers);

export const fetchProjectFileData = (projectId: number) =>
  coreFetchProjectFileData(API, projectId);
